// tslint:disable
export enum PrescriptionBenefitType {
    /**
     * @description Prescription is paid by medical insurance.
     */
    Medical = 1,
    /**
     * @description Prescription is paid by pharmacy benefit manager.
     */
    Pharmacy = 2,
}
(PrescriptionBenefitType as any)['MEDICAL'] = 1;
(PrescriptionBenefitType as any)['PHARMACY'] = 2;
